// Module
var code = "<p>Unlike a regular bill, you have the option to receive an <strong>Interest Bill</strong> while your loans are in deferment, forbearance, grace, or in-school status.</p> ";
// Exports
export default code;